import { pharmacyTechniciansRouteStore } from '../domain/store';

import { listPharmacyTechnicians } from './index';

export default (number) => {
  pharmacyTechniciansRouteStore.setValue('currentPage', number);
  return listPharmacyTechnicians();
};
